import css from './style.module.scss';
import A from '../A';
import Wrap from '../Wrap';
import { motion, AnimateSharedLayout } from 'framer-motion';
import cls from '../../util/cls';

export default function Categories ({ categories, activeId }) {
	return (
		<Wrap className={css.categories}>
			<AnimateSharedLayout>
				<ul>
					<li className={cls({ [css.active]: activeId === void 0 })}>
						{activeId === void 0 && <motion.span layoutId="category" />}
						<A href="/news">All Posts</A>
					</li>
					{categories.map(cat => (
						<li key={cat.key} className={cls({ [css.active]: activeId === cat.key })}>
							{activeId === cat.key && <motion.span />}
							<A href={cat.uri}>{cat.title}</A>
						</li>
					))}
				</ul>
			</AnimateSharedLayout>
		</Wrap>
	);
}
